namespace GeniuzPOS.Lookups {
    export namespace VwSupplItemService {
        export const baseUrl = 'Lookups/VwSupplItem';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwSupplItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwSupplItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwSupplItem/Retrieve",
            List = "Lookups/VwSupplItem/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwSupplItemService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
